import React from 'react'
import Nav from '../Nav/index'
import Footer from '../Footer/index'
import Hero from './Hero/index'
import Content from './Content/index'
import Faqs from './Faqs/index'
import { Helmet } from 'react-helmet'


function index() {


  return (
    <>
            <Helmet>
            <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11084448289"></script>
                    
                    <title>Expert Care for Minor Injuries: Your Trusted Doctors</title>
                    <meta name="description" content="Welcome to Kyno Health, where we understand that minor injuries, though often overlooked, require specialized attention. Our dedicated team of doctors is committed to providing comprehensive care for a range of minor injuries." data-react-helmet="true"/>
                    <link rel="canonical" href="https://www.kynohealth.com/"/>

            </Helmet>
        
    <Nav/>
    <Hero/>
    <Content/>
    <Faqs/>
    <Footer/>
    </>
  )
}





export default index